import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiX, FiZap, FiEdit3, FiCopy, FiCheck, FiCpu } = FiIcons;

const ObituaryHelperModal = ({ isOpen, onClose }) => {
  const [name, setName] = useState('');
  const [keywords, setKeywords] = useState('');
  const [isGenerating, setIsGenerating] = useState(false);
  const [result, setResult] = useState('');
  const [copied, setCopied] = useState(false);

  const generateObituary = () => {
    setIsGenerating(true);
    setTimeout(() => {
      const text = `${name || 'Our beloved'} was a soul of immense light and compassion. Known for their ${keywords || 'kindness and warmth'}, they touched countless lives with a gentle spirit. Their legacy of love remains a guiding star for all who knew them...`;
      setResult(text);
      setIsGenerating(false);
    }, 2000);
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(result);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center p-4 bg-accent-navy/60 backdrop-blur-md">
      <motion.div 
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        className="bg-white rounded-[40px] shadow-2xl w-full max-w-2xl overflow-hidden border border-brand-dark"
      >
        <div className="p-8 md:p-12 border-b border-brand-light flex justify-between items-center bg-accent-navy text-white">
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 bg-accent-gold text-white rounded-2xl flex items-center justify-center shadow-lg">
              <SafeIcon icon={FiEdit3} className="w-6 h-6" />
            </div>
            <div>
              <h3 className="text-2xl font-serif">AI Obituary Assistant</h3>
              <p className="text-[10px] font-black uppercase tracking-widest text-white/60">Respectful Legacy Drafting</p>
            </div>
          </div>
          <button onClick={onClose} className="p-2 hover:bg-white/10 rounded-full text-white/60 transition-colors">
            <SafeIcon icon={FiX} className="w-6 h-6" />
          </button>
        </div>

        <div className="p-8 md:p-12 space-y-8">
          {!result ? (
            <div className="space-y-6">
              <div className="space-y-2">
                <label className="text-[10px] font-black uppercase tracking-widest text-accent-navy">Full Name</label>
                <input 
                  className="w-full px-6 py-4 bg-brand-light border-2 border-brand-dark rounded-2xl focus:border-accent-gold outline-none"
                  placeholder="e.g. Eleanor Grace Thompson"
                  value={name}
                  onChange={e => setName(e.target.value)}
                />
              </div>
              <div className="space-y-2">
                <label className="text-[10px] font-black uppercase tracking-widest text-accent-navy">Core Traits / Memories</label>
                <textarea 
                  className="w-full px-6 py-4 bg-brand-light border-2 border-brand-dark rounded-2xl focus:border-accent-gold outline-none h-24 resize-none"
                  placeholder="e.g. loved gardening, former teacher, extremely generous..."
                  value={keywords}
                  onChange={e => setKeywords(e.target.value)}
                />
              </div>
              <button 
                onClick={generateObituary}
                disabled={isGenerating}
                className="w-full btn-accent py-5 text-lg flex items-center justify-center gap-3 shadow-xl"
              >
                {isGenerating ? (
                  <div className="w-6 h-6 border-2 border-white/30 border-t-white rounded-full animate-spin" />
                ) : (
                  <>Generate Respectful Draft <SafeIcon icon={FiZap} /></>
                )}
              </button>
            </div>
          ) : (
            <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="space-y-6">
              <div className="bg-brand-light p-8 rounded-[32px] border border-brand-dark relative group">
                <div className="absolute top-4 right-4 text-accent-gold opacity-20"><SafeIcon icon={FiCpu} className="w-12 h-12" /></div>
                <p className="text-xl font-serif text-accent-navy leading-relaxed italic">
                  "{result}"
                </p>
              </div>
              <div className="flex gap-4">
                <button onClick={() => setResult('')} className="flex-1 btn-secondary py-4">Start Over</button>
                <button onClick={handleCopy} className="flex-1 btn-primary py-4 flex items-center justify-center gap-2">
                  {copied ? <><SafeIcon icon={FiCheck} /> Copied</> : <><SafeIcon icon={FiCopy} /> Copy Draft</>}
                </button>
              </div>
            </motion.div>
          )}
        </div>
      </motion.div>
    </div>
  );
};

export default ObituaryHelperModal;